import { useQuery } from 'react-query';

import { getCustomerUsersList as queryFn } from 'api/endPoints/getCustomerUsersList';

import { IDataStoryUser } from 'components/Dashboards/Project/Components/DataStories/dataStories.types';

export const useQueryGetCustomerUsersList = () => {
    return useQuery<IDataStoryUser[], QueryError>('customerUsersList', () => queryFn());
};
